/**
 * Site dashboard API — all odl-app endpoints consumed by the site dashboard.
 *
 * Covers the snapshot endpoint, reference catalogs (loaded once per session),
 * the lazy-loaded per-site maintenance-log endpoint, and the feature-association
 * upsert endpoint added with the WEATHER feature gate.
 * User capabilities are fetched via the existing userSettings API path
 * (/api/odl-app/user-settings/me/) and are not duplicated here.
 */
import apiClient from '@sophocles/http-common';

/**
 * Fetch the global reference catalogs (relay_load_types, light_fixtures,
 * alarms, alarm_categories). Call once per session; FE-caches the result.
 *
 * @returns {Promise<{relay_load_types: object[], light_fixtures: object[], alarms: object[], alarm_categories: object[]}>}
 */
export const fetchReference = () => apiClient.get('/odl-app/reference/').then(res => res.data);

/**
 * Fetch maintenance log entries for a site (lazy — loaded when the
 * Maintenance card is opened or the thunk requests it).
 *
 * @param {number|string} siteId
 * @returns {Promise<object>}
 */
export const fetchSiteMaintenanceLog = siteId =>
  apiClient.get(`/odl-app/sites/${siteId}/maintenance-logs/`).then(res => res.data.data);
